export interface TxnScreeningCaseRow {
    id: number;
    caseNo: string;
    fileId: string;
    referenceNo: string;
    direction: string;
    sender: string;
    beneficiary: string;
    hitDate: string;
    amount: number;
    currency: string;
    branch: string;
    channel: string;
    assignee: string;
    osDay: number;
    status: string;
    action: string;
    isMyCase: boolean;
}

export const TXN_SCREENING_FIXTURES: TxnScreeningCaseRow[] = [
    {
        id: 1,
        caseNo: 'TS-001',
        fileId: 'FL-01',
        referenceNo: 'REF1000001',
        direction: 'In',
        sender: 'John Doe',
        beneficiary: 'Acme Corp',
        hitDate: '2024-01-15',
        amount: 15000,
        currency: 'USD',
        branch: 'Main',
        channel: 'SWIFT',
        assignee: 'User1',
        osDay: 5,
        status: 'pending',
        action: 'view',
        isMyCase: true
    },
    {
        id: 2,
        caseNo: 'TS-002',
        fileId: 'FL-02',
        referenceNo: 'REF1000002',
        direction: 'Out',
        sender: 'Jane Smith',
        beneficiary: 'Globex Ltd',
        hitDate: '2024-01-16',
        amount: 8200,
        currency: 'KHR',
        branch: 'Branch A',
        channel: 'RTGS',
        assignee: 'User1',
        osDay: 3,
        status: 'pending',
        action: 'view',
        isMyCase: true
    },
    {
        id: 3,
        caseNo: 'TS-003',
        fileId: 'FL-03',
        referenceNo: 'REF1000003',
        direction: 'In',
        sender: 'Bob Johnson',
        beneficiary: 'Initech',
        hitDate: '2024-01-17',
        amount: 42000,
        currency: 'USD',
        branch: 'Main',
        channel: 'Internal',
        assignee: 'User1',
        osDay: 10,
        status: 'pending',
        action: 'view',
        isMyCase: true
    },
    {
        id: 4,
        caseNo: 'TS-006',
        fileId: 'FL-06',
        referenceNo: 'REF1000006',
        direction: 'Out',
        sender: 'David Lee',
        beneficiary: 'Umbrella Co',
        hitDate: '2024-01-10',
        amount: 5300,
        currency: 'USD',
        branch: 'Branch A',
        channel: 'SWIFT',
        assignee: 'User3',
        osDay: 15,
        status: 'closed',
        action: 'view',
        isMyCase: false
    },
    {
        id: 5,
        caseNo: 'TS-007',
        fileId: 'FL-07',
        referenceNo: 'REF1000007',
        direction: 'In',
        sender: 'Emma Davis',
        beneficiary: 'Stark Industries',
        hitDate: '2024-01-08',
        amount: 91000,
        currency: 'KHR',
        branch: 'Main',
        channel: 'RTGS',
        assignee: 'User3',
        osDay: 20,
        status: 'closed',
        action: 'view',
        isMyCase: false
    }
];

export interface ActivityModel {
    type: 'activity' | 'comment';
    actor: string;
    action: string;
    timestamp: string;
    detail?: string;
}

export const ALL_ACTIVITY_FIXTURES: ActivityModel[] = [
    { type: 'activity', actor: 'Lanh Kongkosol', action: 'updated the case status to', timestamp: '2023-06-11T12:30:00' },
    { type: 'activity', actor: 'Dara Meas', action: 'assigned the case to', timestamp: '2023-06-10T09:15:00' },
    { type: 'activity', actor: 'Sokha Chan', action: 'updated the case status to', timestamp: '2023-06-08T16:45:00' },
    { type: 'comment', actor: 'Sokha Chan', action: 'added a comment', timestamp: '2023-06-08T14:05:00', detail: 'Please review the attached transaction details before approval.' },
    { type: 'comment', actor: 'Dara Meas', action: 'added a comment', timestamp: '2023-06-06T10:20:00', detail: 'Customer provided additional supporting documents for verification.' }
];

export interface FileModel {
    kind: 'jpg' | 'pdf' | 'doc';
    uploadedBy: string;
    uploadedDate: string;
    fileName: string;
}

export const FILE_FIXTURES: FileModel[] = [
    { kind: 'jpg', uploadedBy: 'Heng Sok', uploadedDate: '2024-10-28', fileName: 'ic_jpg.png' },
    { kind: 'pdf', uploadedBy: 'Heng Sok', uploadedDate: '2024-10-28', fileName: 'ic_pdf.png' },
    { kind: 'doc', uploadedBy: 'Dara Meas', uploadedDate: '2024-10-29', fileName: 'ic_doc.png' }
];
